// @flow
import React from 'react';
import type { Node } from 'react';
import { NotificationsConsumer, NotificationsProvider } from '../index';
import type { Notification } from './NotificationsProvider';

export type withNotificationProps<T> = {
  notification: {
    notifications: Notification[],
    addNotification: Notification => number,
    removeNotification: number => void,
    dismiss: () => void,
  },
} & T;

const withNotification = (WrappedComponent: Node) => props => (
  <NotificationsProvider>
    <NotificationsConsumer>
      {notification => (
        <WrappedComponent notification={notification} {...props} />
      )}
    </NotificationsConsumer>
  </NotificationsProvider>
);

export default withNotification;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/notifications/components/withNotification.js